module.exports = __webpack_public_path__ + "img/dhht-0.1eaf23af.png";